<div class="flex justify-center">
  <button *ngIf="isHidden !== true" (click)="btnClicked.emit()" [ngClass]=" active ? 'bg-primary shadow_input' : 'bg-gray-300'"
    class="w-72 md:w-96  md:text-xs lg: xl: text-white cursor-pointer rounded-full border-primary focus:shadow-outline focus:outline-none py-3 md:py-2 px-4 transition duration-300 ease-in-out transform hover:-translate-y-1 hover:scale-110"
    type="button">
    {{ name }}
  </button>
</div>